import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { cartAccountSelector, cartCurrencySelector, cartTotal } from '../redux/selectors/cartSelector';
import {customRound} from "../lib/customRound";
import {getPromoFromArray} from "../utils";
import {promoCodesListSelector} from "../redux/selectors/pagesSelectors";

function useTotal(productId) {
    const [productTotal, setProductTotal] = useState('-');

    const currentAccount = useSelector((state) => cartAccountSelector(state));
    const currency = useSelector((state) => cartCurrencySelector(state));
    const total = useSelector((state) => cartTotal(state, { product_id: null }));
    const promoCodesList = useSelector((state) => promoCodesListSelector(state));
    const promo  = getPromoFromArray(promoCodesList);

    useEffect(() => {

        let sum = total?.total;

        if (promo && +promo?.product_id === +productId) {
            sum = total?.total * promo.discount /100;
        }

        if (total?.total > 0) {
            setProductTotal(
            <>
                {<span dangerouslySetInnerHTML={{ __html: currency?.sign }}></span>}
                {customRound(sum)}
            </>
        );
        } else {
            setProductTotal('-');
        }
    }, [total?.total, currentAccount, productId, promo, currency?.sign]);

    return productTotal;
}

export default useTotal;
